<template>
  <div class="payment-service-list-wrapper max-width">
    <div class="list-header" v-if="isBinded">
      <div
        v-for="(item, i) in listHeaders"
        :key="i"
        @click="changeType(item.type)"
        :class="[type === item.type ?
          'list-header-item-active list-header-item' : 'list-header-item']">
        <p>{{ item.text }}</p>
        <div v-show="type === item.type" class="list-header-line" />
      </div>
    </div>
    <network-error v-if="!net" @retryClick="initData" />
    <loading v-else-if="loading" />
    <no-data v-else-if="empty" :img="details_static.NoProduct" :title="$t('noContents')" />
    <div v-else :class="{'list-wrapper': true, 'list-wrapper-top': this.isBinded}">
      <load-more :top-method="downScrollData" :bottom-method="upScrollData" ref="loadmore">
        <div class="load-wrapper">
          <div class="header" v-if="isFirstPremium">
            <p>
              {{ $t('firstPremiumTips') }}
              <img @click="toAttention" :src="details_static.HelpBlue" alt="HelpBlue">
            </p>
          </div>
          <div class="header" v-else>
            <p>
              {{ $t('listTips') }}
            </p>
            <img
              v-show="!isWithdraw && !isAutopayDate && !isChangePaymentInfo && !isSkipResumePayment"
              @click="toAttention"
              :src="details_static.HelpBlue"
              alt="HelpBlue">
          </div>
          <p class="header-tip" v-if="isModify">
            {{ $t("headerTips") }}
          </p>
          <div class="content">
            <card
              v-for="(card, i) in list"
              :key="'card' + i"
              :title="card.title"
              :tips="card.tips"
              :status="card.status"
              :status-color="card.statusColor"
              @cardClick="toDetail(card)">
              <card-cell
                v-for="(cell, j) in card.data"
                :key="'card-cell' + j"
                :title="cell.title"
                :value="cell.value" />
            </card>
          </div>
          <div class="footer" v-if="isSimple">
            <span @click="policyTips">{{ $t('footTips') }}</span>
          </div>
        </div>
      </load-more>
    </div>
  </div>
</template>

<script>
import { Help_Blue } from '@/images/myCard'
import { No_Product } from '@/images'
import utils from '@/utils/utils'
import { Loading, NoData, NetworkError, LoadMore, Card, CardCell } from '@/components'
import { setNaviMenu, closeSelf, showToast, openPrivateURL } from '@/utils/nativeBridge.js'
import {
  getPaymentServiceList, getApplicationList, getApplicationListForProUser
} from '@/service/pageDetail'
import { getPolicyList } from '@/service/policyChangeService'
import store from '@/store'
import pages from '@/config/pages'
import { clientType } from '@/config/common'
import { statusColor, getDetailTagColor } from '@/config/pageDetail'
import PAYMENT_CATEGORY from '@/config/paymentCategory.js'

const {
  APERIODIC,
  MODIFY,
  SIMPLIFIED,
  FIRST_PREMIUM,
  WITHDRAW,
  CHANGE_AUTOPAY_DATE,
  SKIP_RESUME_PAYMENT,
  CHANGE_PAYMENT_INFO
} = PAYMENT_CATEGORY
const { getUrlQuery, emptyToNA, getUrl, setHtmlTitle, addThousands } = utils
const {
  submitHistoryList,
  PaymentServiceDetail,
  costCalculator,
  skipResumePayment,
  changePaymentInfo,
  PaymentServiceAttention,
  costNotify,
  withdrawAttention,
  changeAutopayDetail
} = pages

export default {
  name: 'PaymentServiceList',
  components: {
    Card,
    CardCell,
    Loading,
    NoData,
    LoadMore,
    NetworkError
  },
  data () {
    return {
      list: [],
      details_static: {
        HelpBlue: Help_Blue,
        NoProduct: No_Product
      },
      type: 1,
      isBinded: false,
      loading: true,
      net: true,
      empty: false,
      bottomStatus: '',
      start: 0,
      total: 0,
      count: 10,
      params: {
        lang: '',
        id: '',
        category: ''
      }
    }
  },
  computed: {
    isSimple () {
      return this.params.category === SIMPLIFIED
    },
    isFirstPremium () {
      return this.params.category === FIRST_PREMIUM
    },
    isWithdraw () {
      return this.params.category === WITHDRAW
    },
    isAutopayDate () {
      return this.params.category === CHANGE_AUTOPAY_DATE
    },
    isSkipResumePayment () {
      return this.params.category === SKIP_RESUME_PAYMENT
    },
    isChangePaymentInfo () {
      return this.params.category === CHANGE_PAYMENT_INFO
    },
    isModify () {
      return this.params.category === MODIFY
    },
    listHeaders () {
      return [
        {
          type: 1,
          text: this.$t('startAuditing')
        },
        {
          type: 2,
          text: this.$t('waitAuditing')
        }
      ]
    }
  },
  watch: {
    bottomStatus (newVal, oldVal) {
      if (newVal !== oldVal) {
        setTimeout(() => {
          const loadmore = this.$refs.loadmore
          if (!loadmore) return
          switch (newVal) {
            case 'end':
              loadmore.onBottomEnd()
              break
            case 'noData':
              loadmore.onBottomEmpty()
              break
            case 'error':
              loadmore.onBottomError()
              break
            default:
              loadmore.onBottomEnd()
          }
        }, 0)
      }
    }
  },
  mounted () {
    this.setNative()
  },
  created () {
    this.initData()
  },
  methods: {
    // 下拉刷新
    downScrollData () {
      this.getData()
        .then(data => {
          this.start = 0
          this.total = 0
          this.list.splice(0)
          this.dealData(data)
        })
        .catch(() => {
          showToast(this.$t('netErrorToast'), 1)
        })
        .finally(() => {
          this.$refs.loadmore && this.$refs.loadmore.onTopEnd()
        })
    },
    // 上拉加载
    upScrollData () {
      this.getData(this.start)
        .then(data => {
          this.dealData(data)
        })
        .catch(() => {
          this.bottomStatus = 'error'
        })
        .finally(() => {
          if (!this.bottomStatus) this.bottomStatus = 'end'
        })
    },
    // 审核状态改变
    changeType (type) {
      if (this.loading) return
      this.type = type
      this.initData()
    },
    // 跳转支付记录
    goPaymentRecord () {
      const url = getUrl(submitHistoryList, {
        category: this.params.category,
        lang: this.params.lang
      })
      openPrivateURL(url)
    },
    // 跳转详情
    toDetail (card) {
      // console.log('To Detail')
      let pageId = PaymentServiceDetail
      // const reg = new RegExp(`${APERIODIC}|${MODIFY}|${FIRST_PREMIUM}|${SKIP_RESUME_PAYMENT}`)
      if (this.params.category === APERIODIC | this.params.category === MODIFY |
        this.params.category === FIRST_PREMIUM) {
        pageId = costCalculator
      } else if (this.isWithdraw) {
        pageId = withdrawAttention
      } else if (this.isSkipResumePayment) {
        pageId = skipResumePayment
      } else if (this.isChangePaymentInfo) {
        pageId = changePaymentInfo
      } else if (this.isAutopayDate) {
        pageId = changeAutopayDetail
      }
      const policyappid = card.policyappid === 'N/A' ? '' : card.policyappid
      const url = getUrl(pageId, {
        id: card.policyno,
        category: this.params.category,
        lang: this.params.lang,
        policyappid
      })
      openPrivateURL(url)
    },
    // 跳转注意事项
    toAttention () {
      let pageId = PaymentServiceAttention
      const reg = new RegExp(`${APERIODIC}|${MODIFY}`)
      if (reg.test(this.params.category)) {
        pageId = costNotify
      }
      const url = getUrl(pageId, {
        category: this.params.category,
        lang: this.params.lang
      })
      openPrivateURL(url)
    },
    // 未找到保单提示
    policyTips () {
      const cTemplate = `
        <pre class="about-policy-reinstatement">${this.$t('contentPolicyReinstatement')}</pre>
      `
      this.$DialogBox({
        title: this.$t('aboutPolicyReinstatement'),
        contentHtml: cTemplate,
        confirmText: this.$t('confirm'),
        showCancel: false
      })
        .then(() => {})
        .catch(() => {})
    },
    getCurrency (currency) {
      if (currency === 'HK$') {
        return 'HKD'
      } else if (currency === 'US$') {
        return 'USD'
      }
      return currency
    },
    // 处理数据
    dealData (data) {
      this.start += data.count
      this.total = data.total
      if (this.start >= this.total) {
        this.bottomStatus = 'noData'
      } else {
        this.bottomStatus = ''
      }
      data.policies && data.policies.forEach(item => {
        const {
          policyno,
          policyappid,
          productname,
          chinesename,
          englishname,
          insurantchinesename,
          insurantenglishname,
          policystatus,
          policyeffectivedate,
          insurancematuritydate,
          regularinsurance,
          currency,
          autopaydate,
          paymode
        } = item
        let newregularinsurance
        if (typeof regularinsurance === 'number') {
          newregularinsurance = regularinsurance
            ? `${this.getCurrency(currency)} ${addThousands(regularinsurance.toFixed(2))}` : ''
        } else {
          newregularinsurance = regularinsurance
            ? `${this.getCurrency(currency)} ${regularinsurance}` : ''
        }
        let newItem
        if (this.isFirstPremium) {
          newItem = {
            policyno,
            policyappid,
            title: productname,
            status: this.type === 2
              ? this.$t('applicationstatus')[1] : this.$t('applicationstatus')[policystatus],
            statusColor: this.type === 2
              ? getDetailTagColor.application[1] : getDetailTagColor.application[policystatus],
            data: [
              {
                title: this.$t('policyNo'),
                value: policyno
              },
              {
                title: this.$t('proposedInsured'),
                value: this.type === 2
                  ? `${insurantchinesename} ${insurantenglishname}`.trim()
                  : `${chinesename} ${englishname}`.trim()
              },
              {
                title: this.$t('regularPremium'),
                value: newregularinsurance
              }
            ]
          }
        } else if (this.params.category === WITHDRAW) {
          newItem = {
            policyno,
            policyappid,
            title: productname,
            status: this.$t('policystatus')[policystatus],
            statusColor: policystatus === 1 ? statusColor.Inforce : statusColor.Terminated,
            data: [
              {
                title: this.$t('policyNo'),
                value: policyno
              },
              {
                title: this.$t('insureName'),
                value: `${chinesename} ${englishname}`.trim()
              }
            ]
          }
        } else if (this.params.category === CHANGE_AUTOPAY_DATE) {
          newItem = {
            policyno,
            policyappid,
            title: productname,
            status: this.$t('status')[policystatus],
            statusColor: policystatus === 1 ? statusColor.Inforce : statusColor.Terminated,
            data: [
              {
                title: this.$t('policyNo'),
                value: policyno
              },
              {
                title: this.$t('insureName'),
                value: `${chinesename} ${englishname}`.trim()
              },
              {
                title: this.$t('autoDate'),
                value: this.$t('autoPayDate')[autopaydate]
              }
            ]
          }
        } else if (this.params.category === CHANGE_PAYMENT_INFO) {
          newItem = {
            policyno,
            policyappid,
            title: productname,
            status: this.$t('status')[policystatus],
            statusColor: policystatus === 1 ? statusColor.Inforce : statusColor.Terminated,
            data: [
              {
                title: this.$t('policyNo'),
                value: policyno
              },
              {
                title: this.$t('insureName'),
                value: `${chinesename} ${englishname}`.trim()
              },
              {
                title: this.$t('paymentMethod'),
                value: paymode
              }
            ]
          }
        } else {
          newItem = {
            policyno,
            policyappid,
            title: productname,
            status: this.$t('policystatus')[policystatus],
            statusColor: policystatus === 1 ? statusColor.Inforce : statusColor.Terminated,
            data: [
              {
                title: this.$t('policyNo'),
                value: policyno
              },
              {
                title: this.$t('insureName'),
                value: `${chinesename} ${englishname}`.trim()
              },
              {
                title: this.$t('takeEffectDate'),
                value: policyeffectivedate
              },
              {
                title: this.$t('expireDate'),
                value: insurancematuritydate
              }
            ]
          }
        }
        if (this.isSimple) {
          newItem.tips = this.$t('simpleTips')
        }
        this.list.push(emptyToNA(newItem))
      })
    },
    getData (start = 0) {
      if (this.isWithdraw || this.isAutopayDate) {
        // 即磅
        return getPolicyList(store.mmaclientid, 1, this.params.category, start, this.count)
      }
      if (!this.isFirstPremium) {
        // 非首期保费
        return getPaymentServiceList(store.mmaclientid, this.params.category, start, this.count)
      }
      if (this.isBinded && this.type === 1) {
        // 客户-开始审核
        return getApplicationList(store.mmaclientid, 4, start, this.count)
      }
      // 客户-尚未审核 && 准客户
      return getApplicationListForProUser(store.uin, start, this.count)
    },
    startLoading () {
      this.loading = true
    },
    endLoading () {
      this.loading = false
    },
    startNet () {
      this.net = true
    },
    endNet () {
      this.net = false
    },
    initStatus () {
      this.start = 0
      this.total = 0
      this.list = []
      this.net = true
      this.loading = true
      this.empty = false
    },
    initClientStatus () {
      this.isBinded = this.isFirstPremium && store.clientType === clientType.binded
      if (store.clientType !== clientType.binded) {
        this.type = 2
      }
    },
    getQuery () {
      const params = getUrlQuery()
      this.params.lang = params.lang
      this.params.category = params.category
      setHtmlTitle(this.$t('titleArrays')[this.params.category]) // 设置标题
    },
    setNative () {
      setNaviMenu([{
        position: 'left',
        title: '',
        iconId: 'icon_navi_back',
        event: 'paymentServiceListClose',
        callBack: closeSelf
      }, {
        position: 'right',
        title: '',
        iconId: 'icon_navi_record',
        event: 'paymentServiceListRecord',
        callBack: this.goPaymentRecord
      }])
    },
    // 初始化数据
    initData () {
      this.initStatus()
      this.getQuery()
      this.initClientStatus()
      this.getData()
        .then(data => {
          this.dealData(data)
          if (!this.list.length) {
            this.empty = true
          }
        })
        .catch((err) => { // 初始化网络错误
          console.error(err)
          this.endNet()
        })
        .finally(() => {
          this.endLoading()
        })
    }
  }
}
</script>

<style lang="scss">
body {
  background: $color-stage1;
}
.about-policy-reinstatement {
  color: $color-text;
  font-size: $span-font-size;
  line-height: 20px;
}
.about-policy-reinstatement-phone {
  color: $color-primary;
  font-size: $span-font-size;
  line-height: 20px;
}
</style>
<style lang="scss" scoped>
@import "./index.scss";
</style>
